export enum VolunteerType {
  COMPANION_SUPPORT_TO_PATIENT_FAMILY = 1,
  OFFICE_ADMIN,
  SPECIAL_PROJECTS = 4,
  PROFESSIONAL_SERVICE_TO_PATIENT_FAMILY = 8,
}



// WEBPACK FOOTER //
// ./src/models/resource-management/volunteers/volunteer-type.ts